import { ResultMsg as LoganOpenSourceResultMsg } from 'logan-web/build/interface';
var resultF = function (code, msg) {
    return {
        code: code,
        msg: msg
    };
};
// 用于Owl打点的结果码
export var ResultEnum = {
    'DB_NOT_SUPPORT': resultF(2100, '当前浏览器不支持日志功能'),
    'SAVE_SUCC': resultF(2200, '存储成功'),
    'SAVE_LOG_FAIL': resultF(2201, '存储日志异常'),
    'EXCEED_SINGLE_LOG_LIMIT': resultF(2301, '超出单条日志容量限额'),
    'EXCEED_DAY_LIMIT': resultF(2302, '超出当天日志容量限额'),
    'NO_LOG': resultF(2303, '当天没有日志'),
    'REPORT_SUCC': resultF(2400, '上报成功'),
    'REPORT_ERROR': resultF(2402, '上报异常'),
    'INVALID_HTTP': resultF(2403, '禁止http协议上报至线上环境'),
    'OTHER_ERROR': resultF(2666, '其他异常'),
    'KNB_SAVE_SUCC': resultF(2700, '桥接存储成功'),
    'KNB_SAVE_FAIL': resultF(2701, '桥接存储异常'),
    'PREREPORT_QUERY_ERROR': resultF(2800, '前置上报问询异常')
};
// 用于上报结果展示
export var SingleReportResultEnum = {
    'REPORT_SUCC': resultF(400, '上报成功'),
    'NO_LOG': resultF(303, '没有日志'),
    'AJAX_ERROR': resultF(402, '上报接口失败'),
    'SERVER_ERROR': resultF(403, '上报服务端有错'),
    'OTHER_ERROR': resultF(404, '其它错误')
};
export function transOpensourceResultToReportResult(resultMsg, desc) {
    switch (resultMsg) {
        case LoganOpenSourceResultMsg.NO_LOG:
            return SingleReportResultEnum.NO_LOG;
        case LoganOpenSourceResultMsg.REPORT_LOG_SUCC:
            return SingleReportResultEnum.REPORT_SUCC;
        case LoganOpenSourceResultMsg.REPORT_LOG_FAIL:
            if (desc && desc.indexOf('Server error') === 0) {
                return {
                    code: SingleReportResultEnum.SERVER_ERROR.code,
                    msg: SingleReportResultEnum.SERVER_ERROR.msg,
                    desc: desc
                };
            }
            else {
                return {
                    code: SingleReportResultEnum.AJAX_ERROR.code,
                    msg: SingleReportResultEnum.AJAX_ERROR.msg,
                    desc: desc
                };
            }
        default:
            return {
                code: SingleReportResultEnum.OTHER_ERROR.code,
                msg: SingleReportResultEnum.OTHER_ERROR.msg,
                desc: desc
            };
    }
}
